import { Outlet } from 'react-router';

import { LayoutContainer } from '@/components/layout/container';
import { CookieContainer } from '@/components/layout/cookie-container';

export function ErrorLayout() {
  return (
    <CookieContainer>
      <LayoutContainer>
        <main style={{ flex: 1 }}>
          <Outlet />
        </main>
      </LayoutContainer>
    </CookieContainer>
  );
}
